import axios from "axios";

import {ENV_URL} from './Globals';
const API_URL = `${ENV_URL}/api/v1/mail/`;

class EmailService {
  sendMail( name, mailFrom ,  mailSubject , mailContent , mailTo ) {
    return axios
      .post(API_URL, {
        name,
        mailFrom,
        mailSubject,
        mailContent,
        mailTo
      });
  }


  contactUs( name, mailFrom ,  mailSubject , mailContent ) {
    return axios
      .post(API_URL+"contactus", {
        name,
        mailFrom,
        mailSubject,
        mailContent,
      });
    }
  }


  
const emailService = new EmailService();
export default emailService;